import React, { Dispatch, ReactNode } from 'react';
import Popup from '../../Popup/Popup';
import LoginForm from '../../Forms/LoginForm/LoginForm';

type UserLoginPopUpT = {
  showLoginPopup: boolean;
  setShowLoginPopup?: Dispatch<boolean>;
  children?: ReactNode;
  onLoginSuccess?: () => void;
};

const UserLoginPopUp = ({
  children,
  showLoginPopup,
  setShowLoginPopup,
  onLoginSuccess,
}: UserLoginPopUpT) => {
  return (
    <>
      {children}
      <Popup
        centered
        show={showLoginPopup}
        onHide={() => {
          if (setShowLoginPopup) {
            setShowLoginPopup(false);
          }
        }}
      >
        <div className={'p-5'}>
          <h2 style={{ fontStyle: 'italic' }} className={'pb-3 fw-black'}>
            Account login
          </h2>
          <LoginForm onLoginSuccess={onLoginSuccess} />
        </div>
      </Popup>
    </>
  );
};

export default UserLoginPopUp;
